var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"animated-number"},[_vm._v(" "+_vm._s(_vm.filter(_vm.animatedNumber))+" "),_vm._t("default",null,{"animatedNumber":_vm.animatedNumber})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }